import { render, staticRenderFns } from "./BillUser.vue?vue&type=template&id=bb68ffde&scoped=true"
import script from "./BillUser.vue?vue&type=script&lang=js"
export * from "./BillUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb68ffde",
  null
  
)

export default component.exports